import type { CSSObject } from '@emotion/react'
import type { TEmitterType } from '@semios/app-platform-values-helpers-and-types'
import type { TPressureReading } from 'App/Map/CurrentValuesMap/_utils/by-domain/_utils/getPressureReading'
import type { TIrrigationDeviceStatus, TLngLat } from 'App/Map/types'
import { MapItemsCache } from 'components/GoogleMap/MapItemsCache'
import type { ReactComponentOverlayView } from 'components/GoogleMap/_utils/makeReactComponentOverlayView'
import { makeReactComponentOverlayView } from 'components/GoogleMap/_utils/makeReactComponentOverlayView'
import type { TBlockId, TPropertyId } from 'stores/fieldAssetStore/helperTypes'
import type { TStationBadgeComponentProps } from './StationBadgeComponent/StationBadgeComponent'
import { StationBadgeComponent } from './StationBadgeComponent/StationBadgeComponent'

export type STATION_META = {
  propertyId: TPropertyId
  blockId?: TBlockId
  lngLat: TLngLat
  name: string
  latLng: google.maps.LatLng
  isOutOfBlock: boolean
  irrigationActivity?: TIrrigationActivityForPointOrZone
  irrigationZoneId?: number
  emitterTypes: TEmitterType[]
}

export type TIrrigationActivityForPointOrZone = Record<
  string,
  {
    getBadgeColors: () => {
      backgroundColor: string
      color: string
    }
    duration: number | null
    applied: number | null
    status: TIrrigationDeviceStatus
    pressure?: TPressureReading
    flowRate?: {
      rate: number
      isDefault: boolean
      mmPerHour: number
      unitsPerHour: 'INCH' | 'MILLIMETER'
    }
  }
>

// TODO: will eventually come from current values type
export type TStationsValueTypesToPropsDictionary = Record<
  string,
  {
    baseZIndex?: number
    children: React.ReactNode
    getContainerCSS: () => CSSObject
    valuesForPoint?: TIrrigationActivityForPointOrZone
    getSize?: () => number | null
    shouldAddDataSourceOverlay?: boolean
    isWeatherStation?: boolean
  }
>

export class StationValuesCache extends MapItemsCache<
  STATION_META,
  TStationsValueTypesToPropsDictionary,
  ReactComponentOverlayView<TStationBadgeComponentProps>
> {
  constructor(options: { maps: typeof google.maps; map: google.maps.Map }) {
    super({
      createOverlay: (o) => {
        return makeReactComponentOverlayView({
          component: StationBadgeComponent,
          latLng: o.meta.latLng,
          maps: o.maps,
          map: o.map,
        })
      },
      renderOverlay: (o) => {
        o.overlay.render({ ...o, valueTypesToPropsDictionary: o.value })
      },
      hideOverlay: (o) => {
        o.overlay.setMap(null)
      },
      maps: options.maps,
      map: options.map,
    })
  }
}
